import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { gamesMeta } from '@shared/data/gamesMeta';

function statusLabel(status: string | undefined) {
  if (status === 'in-preparation') return 'W PRZYGOTOWANIU';
  if (status === 'partial') return 'CZĘŚCIOWA';
  return 'INSTRUKCJA';
}

export function LibraryScreen() {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLocaleLowerCase('pl');
    if (!q) return gamesMeta;
    return gamesMeta.filter((game) =>
      `${game.title} ${game.subtitle}`.toLocaleLowerCase('pl').includes(q)
    );
  }, [query]);

  return (
    <section>
      <p className="eyebrow">Moja biblioteka</p>
      <h1>Planszówki</h1>
      <p className="subtitle">
        Pełne instrukcje, dodatki i FAQ — także offline w trybie PWA.
      </p>

      <div className="search-box">
        <span aria-hidden>⌕</span>
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Szukaj gry lub dodatku"
          aria-label="Szukaj gry"
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
        <h2 style={{ fontSize: '1.35rem' }}>Wszystkie gry</h2>
        <span className="offline-pill">{filtered.length}</span>
      </div>

      {filtered.length === 0 ? (
        <div className="empty">
          <h2>Nie znaleziono gry</h2>
          <p className="subtitle">Spróbuj innej nazwy.</p>
        </div>
      ) : (
        <div className="game-grid">
          {filtered.map((game) => (
            <Link key={game.id} to={`/game/${game.id}`} className="game-card">
              <div className="game-card-cover">
                {game.logoFile ? (
                  <img
                    src={`/game-logos/${game.logoFile}`}
                    alt={game.logoAccessibilityLabel ?? game.title}
                  />
                ) : (
                  <span style={{ fontSize: 48 }}>{game.icon}</span>
                )}
                <span className="badge">{statusLabel(game.contentStatus)}</span>
              </div>
              <div className="game-card-body">
                <h2>{game.title}</h2>
                <p className="meta">{game.subtitle}</p>
                <p className="meta">
                  {game.players} · {game.playTime}
                </p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
